import React, { useState } from 'react';
import { motion } from "framer-motion";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import { containerVariants, photoVariants } from '../../variants/variants';

const Section2 = () => {
    const images = [
        '/images/production/1.jpg',
        '/images/production/2.jpg',
        '/images/production/3.jpg',
        '/images/production/4.jpg',
        '/images/production/5.jpg',
        '/images/production/6.jpg',
        '/images/production/7.jpg',
        '/images/production/8.jpg',
    ];

    const layout = [
        { type: 'single', images: [images[0]] },
        { type: 'grid', images: [images[1], images[2]] },
        { type: 'grid', images: [images[3], images[4]] },
        { type: 'single', images: [images[5]] },
        { type: 'grid', images: [images[6], images[7]] },
    ];

    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);

    // Flatten the layout to get a simple array of all images in display order
    const flatImages = layout.flatMap((section) => section.images);

    const handleImageClick = (index) => {
        setCurrentIndex(index); // Pass the exact index of the clicked image
        setLightboxOpen(true);
    };

    return (
        <>
            <motion.div
                initial="hidden"
                whileInView="visible"
                exit="exit"
                variants={containerVariants}
                className="!overflow-hidden"
            >
                {layout.map((section, sectionIndex) => (
                    <motion.div
                        key={sectionIndex}
                        className={`!overflow-hidden ${section.type === 'grid' ? 'grid grid-cols-2' : ''}`}
                    >
                        {section.images.map((src, idx) => {
                            const flatIndex = flatImages.indexOf(src); // Get the correct index in the flattened array
                            return (
                                <motion.img
                                    key={idx}
                                    src={src}
                                    alt={`Production ${sectionIndex}-${idx}`}
                                    variants={photoVariants}
                                    initial="initial"
                                    whileInView="whileInView"
                                    exit="exit"
                                    className="cursor-pointer"
                                    onClick={() => handleImageClick(flatIndex)} // Pass the correct index
                                />
                            );
                        })}
                    </motion.div>
                ))}
            </motion.div>

            {/* Lightbox */}
            <Lightbox
                open={lightboxOpen}
                close={() => setLightboxOpen(false)}
                slides={flatImages.map((src) => ({ src }))}
                index={currentIndex}
            />
        </>
    );
};

export default Section2;
